import React from 'react';
import './User.css';
import Navbar from '../../Components/Navbar/Navbar';
import Banner from '../../Components/Banner/Banner';
import Breakdrum from '../../Components/Breakdrum/Breakdrum';
import Latest from '../../Components/Latest/Latest';
import Best from '../../Components/Best/Best';
import Footer from '../../Components/Footer/Footer';
import { useNav } from '../../Context/NavContext';
import Collection from '../../Components/Collection/Collection';
import About from '../../Components/About/About';
import Contact from '../../Components/Contact/Contact';
import Access from '../../Components/Access/Access';
import Product from '../../Components/Product/Product';
import Related from '../../Components/Related/Related';
import Cart from '../../Components/Cart/Cart';
import Reviews from '../../Components/Reviews/Reviews';
import AddReview from '../../Components/AddReview/AddReview';

function User() {
  const { activeItem } = useNav();

  return (
    <div className='user_container'>
      <div className="user_nav_container">
        <Navbar />
      </div>

      <div className="user_body_container">
        {activeItem === 'HOME' && (
          <div className="home_components">
            <Banner />
            <Breakdrum
              title="Latest Collections"
              para="Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam nihil iste dicta, maiores ab necessitatibus ut quod excepturi"
            />
            <Latest />
            <Breakdrum
              title="Best Sellers"
              para="Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam nihil iste dicta, maiores ab necessitatibus ut quod excepturi"
            />
            <Best />
            <Breakdrum
              title="What Our Customers Say"
              para="Read genuine reviews from our valued customers about their shopping experience"
            />
            <Reviews />
            <AddReview/>
            <Footer />
          </div>
        )}

        {activeItem === 'COLLECTION' && (
          <div className="collection_components">
            <Collection/>
            <Footer />
          </div>
        )}

        {activeItem === 'ABOUT' && (
          <div className="about_components">
            <About/>
                <Footer />
          </div>
        )}

        {activeItem === 'CONTACT' && (
          <div className="contact_components">
            <Contact/>
                 <Footer />
          </div>
        )}

          {activeItem === 'ACCESS' && (
          <div className="access_components">
            <Access/>
                 <Footer />
          </div>
        )}

         {activeItem === 'PRODUCT' && (
          <div className="product_components">
            <Product/>
            <Breakdrum
              title="Related Products"
              para="Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam nihil iste dicta, maiores ab necessitatibus ut quod excepturi"
            />
            <Related/>
                 <Footer />
          </div>
        )}

         {activeItem === 'CART' && (
          <div className="cart_components">
            <Cart/>
                 <Footer />
          </div>
        )}
      </div>

    </div>
  );
}

export default User;
